import Vue from 'vue'
import Vuex from 'vuex'
import AvatarVoiceFIcon from '../../assets/avatarVoiceF.png'
import AvatarVoiceMIcon from '../../assets/avatarVoiceM.png'
import { moduleLanguages } from './languages'
import { moduleCountries } from './countries'

Vue.use(Vuex)


export const store = new Vuex.Store({
	modules: {
		languages: moduleLanguages,
		countries: moduleCountries
	},
	state: {
		samples: [
			{
				avatar: AvatarVoiceFIcon,
				title: 'Celesta',
				person: 'Celesta',
				gender: 'female',
				languageName: 'Spanish',
				languageCode: "es-ES",
				languageCodeFull: "es-ES-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/es_es_s1_Celesta.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/es_es_s1_Celesta.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Grete',
				person: 'Grete',
				gender: 'female',
				languageName: 'Danish',
				languageCode: "da-DK",
				languageCodeFull: "da-DK-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/da_dk_s1_Grete.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/da_dk_s2_Grete.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Ingrid',
				person: 'Ingrid',
				gender: 'female',
				languageName: 'Danish',
				languageCode: "da-DK",
				languageCodeFull: "da-DK-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/da_dk_s3_Ingrid.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/da_dk_s4_Ingrid.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Adelie',
				person: 'Adelie',
				gender: 'female',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s1_Adelie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s1_Adelie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Hannah',
				person: 'Hannah',
				gender: 'female',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s2_Hannah.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s2_Hannah.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Liezel',
				person: 'Liezel',
				gender: 'female',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s3_Liezel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s3_Liezel.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Dietmar',
				person: 'Dietmar',
				gender: 'male',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s1_Dietmar.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s1_Dietmar.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Knut',
				person: 'Knut',
				gender: 'male',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s2_Knut.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s2_Knut.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Siegfrid',
				person: 'Siegfrid',
				gender: 'male',
				languageName: 'German',
				languageCode: "de-DE",
				languageCodeFull: "de-DE-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/de_de_s3_Siegfrid.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/de_de_s3_Siegfrid.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Allese',
				person: 'Allese',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s1_Allese.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s1_Allese.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Chloe',
				person: 'Chloe',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s2_Chloe.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s2_Chloe.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Louise',
				person: 'Louise',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s3_Louise.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s3_Louise.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Symone',
				person: 'Symone',
				gender: 'female',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s4_Symone.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s4_Symone.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Emanuel',
				person: 'Emanuel',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s1_Emanuel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s1_Emanuel.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Fabien',
				person: 'Fabien',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s2_Fabien.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s2_Fabien.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Raphael',
				person: 'Raphael',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s3_Raphael.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s3_Raphael.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Thierry',
				person: 'Thierry',
				gender: 'male',
				languageName: 'French, Canada',
				languageCode: "fr-CA",
				languageCodeFull: "fr-CA-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_ca_s4_Thierry.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_ca_s4_Thierry.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Jerome',
				person: 'Jerome',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s1_Jerome.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s1_Jerome.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Maurice',
				person: 'Maurice',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s2_Maurice.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s2_Maurice.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Sinclaire',
				person: 'Sinclaire',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s3_Sinclaire.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s3_Sinclaire.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Travis',
				person: 'Travis',
				gender: 'male',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s4_Travis.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s4_Travis.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Amelie',
				person: 'Amelie',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s1_Amelie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s1_Amelie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Dennise',
				person: 'Dennise',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s2_Dennise.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s2_Dennise.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Lisette',
				person: 'Lisette',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s3_Lisette.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s3_Lisette.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Sophie',
				person: 'Sophie',
				gender: 'female',
				languageName: 'French',
				languageCode: "fr-FR",
				languageCodeFull: "fr-FR-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/fr_fr_s4_Sophie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/fr_fr_s4_Sophie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Giulia',
				person: 'Giulia',
				gender: 'female',
				languageName: 'Italian',
				languageCode: "it-IT",
				languageCodeFull: "it-IT-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/it_it_s1_Giulia.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/it_it_s2_Giulia.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Francesca',
				person: 'Francesca',
				gender: 'female',
				languageName: 'Italian',
				languageCode: "it-IT",
				languageCodeFull: "it-IT-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/it_it_s3_Francesca.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/it_it_s4_Francesca.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'ChinSun',
				person: 'ChinSun',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s1_ChinSun.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s1_ChinSun.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'HaJoon',
				person: 'HaJoon',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s2_HaJoon.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s2_HaJoon.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'KyungMi',
				person: 'KyungMi',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s3_KyungMi.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s3_KyungMi.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'MinJung',
				person: 'MinJung',
				gender: 'female',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s4_MinJung.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s4_MinJung.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'DongMin',
				person: 'DongMin',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s1_DongMin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s1_DongMin.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'HoSook',
				person: 'HoSook',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s2_HoSook.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s2_HoSook.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'SangOok',
				person: 'SangOok',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s3_SangOok.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s3_SangOok.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'YooJoon',
				person: 'YooJoon',
				gender: 'male',
				languageName: 'Korean',
				languageCode: "ko-KR",
				languageCodeFull: "ko-KR-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ko_kr_s4_YooJoon.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ko_kr_s4_YooJoon.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Annemari',
				person: 'Annemari',
				gender: 'female',
				languageName: 'Norwegian',
				languageCode: "nb-NO",
				languageCodeFull: "nb-NO-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nb_no_s1_Annemari.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nb_no_s2_Annemari.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Kaari',
				person: 'Kaari',
				gender: 'female',
				languageName: 'Norwegian',
				languageCode: "nb-NO",
				languageCodeFull: "nb-NO-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nb_no_s3_Kaari.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nb_no_s4_Kaari.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Jasmijn',
				person: 'Jasmijn',
				gender: 'female',
				languageName: 'Dutch, Netherlands',
				languageCode: "nl-NL",
				languageCodeFull: "nl-NL-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nl_nl_s1_Jasmijn.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nl_nl_s2_Jasmijn.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Lotte',
				person: 'Lotte',
				gender: 'female',
				languageName: 'Dutch, Netherlands',
				languageCode: "nl-NL",
				languageCodeFull: "nl-NL-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/nl_nl_s3_Lotte.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/nl_nl_s4_Lotte.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Bozena',
				person: 'Bozena',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s1_Bozena.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s1_Bozena.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Elzbieta',
				person: 'Elzbieta',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s2_Elzbieta.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s2_Elzbieta.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Halinka',
				person: 'Halinka',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s3_Halinka.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s3_Halinka.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Lidia',
				person: 'Lidia',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s4_Lidia.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s4_Lidia.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Natasza',
				person: 'Natasza',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s5_Natasza.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s5_Natasza.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Zuzanna',
				person: 'Zuzanna',
				gender: 'female',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s6_Zuzanna.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s6_Zuzanna.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Antek',
				person: 'Antek',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s1_Antek.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s1_Antek.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Bolek',
				person: 'Bolek',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s2_Bolek.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s2_Bolek.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Szymon',
				person: 'Szymon',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s3_Szymon.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s3_Szymon.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Wojciech',
				person: 'Wojciech',
				gender: 'male',
				languageName: 'Polish',
				languageCode: "pl-PL",
				languageCodeFull: "pl-PL-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pl_pl_s4_Wojciech.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pl_pl_s4_Wojciech.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Francisca',
				person: 'Francisca',
				gender: 'female',
				languageName: 'Portuguese, Brazil',
				languageCode: "pt-BR",
				languageCodeFull: "pt-BR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_br_s1_Francisca.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_br_s1_Francisca.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Marcia',
				person: 'Marcia',
				gender: 'female',
				languageName: 'Portuguese, Brazil',
				languageCode: "pt-BR",
				languageCodeFull: "pt-BR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_br_s2_Marcia.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_br_s2_Marcia.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Beatriz',
				person: 'Beatriz',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s1_Beatriz.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s1_Beatriz.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Cesaria',
				person: 'Cesaria',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s2_Cesaria.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s2_Cesaria.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Leonor',
				person: 'Leonor',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s3_Leonor.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s3_Leonor.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Miciela',
				person: 'Miciela',
				gender: 'female',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s4_Miciela.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s4_Miciela.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Alfonso',
				person: 'Alfonso',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s1_Alfonso.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s1_Alfonso.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Filipe',
				person: 'Filipe',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s2_Filipe.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s2_Filipe.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Miguel',
				person: 'Miguel',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s3_Miguel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s3_Miguel.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Rodrigo',
				person: 'Rodrigo',
				gender: 'male',
				languageName: 'Portuguese, Portugal',
				languageCode: "pt-PT",
				languageCodeFull: "pt-PT-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/pt_pt_s4_Rodrigo.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/pt_pt_s4_Rodrigo.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Artem',
				person: 'Artem',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s1_Artem.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s1_Artem.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Igor',
				person: 'Igor',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s2_Igor.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s2_Igor.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Sergey',
				person: 'Sergey',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s3_Sergey.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s3_Sergey.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Vova',
				person: 'Vova',
				gender: 'male',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s4_Vova.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s4_Vova.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Anya',
				person: 'Anya',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s1_Anya.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s1_Anya.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Katja',
				person: 'Katja',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s2_Katja.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s2_Katja.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Nastya',
				person: 'Nastya',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s3_Nastya.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s3_Nastya.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Olga',
				person: 'Olga',
				gender: 'female',
				languageName: 'Russian',
				languageCode: "ru-RU",
				languageCodeFull: "ru-RU-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ru_ru_s4_Olga.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ru_ru_s4_Olga.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Dalenka',
				person: 'Dalenka',
				gender: 'female',
				languageName: 'Slovak',
				languageCode: "sk-SK",
				languageCodeFull: "sk-SK-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sk_sk_s1_Dalenka.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sk_sk_s1_Dalenka.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Ladislava',
				person: 'Ladislava',
				gender: 'female',
				languageName: 'Slovak',
				languageCode: "sk-SK",
				languageCodeFull: "sk-SK-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sk_sk_s2_Ladislava.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sk_sk_s2_Ladislava.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Astrid',
				person: 'Astrid',
				gender: 'female',
				languageName: 'Swedish',
				languageCode: "sv-SE",
				languageCodeFull: "sv-SE-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sv_se_s1_Astrid.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sv_se_s1_Astrid.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Caren',
				person: 'Caren',
				gender: 'female',
				languageName: 'Swedish',
				languageCode: "sv-SE",
				languageCodeFull: "sv-SE-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/sv_se_s2_Caren.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/sv_se_s2_Caren.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Aylin',
				person: 'Aylin',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s1_Aylin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s1_Aylin.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Emel',
				person: 'Emel',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s2_Emel.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s2_Emel.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Filiz',
				person: 'Filiz',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s3_Filiz.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s3_Filiz.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Nehir',
				person: 'Nehir',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s4_Nehir.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s4_Nehir.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Reyhan',
				person: 'Reyhan',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s5_Reyhan.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s5_Reyhan.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Zeynep',
				person: 'Zeynep',
				gender: 'female',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s6_Zeynep.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s6_Zeynep.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Ahmet',
				person: 'Ahmet',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s1_Ahmet.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s1_Ahmet.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Ergin',
				person: 'Ergin',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s2_Ergin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s2_Ergin.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Muhammed',
				person: 'Muhammed',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s3_Muhammed.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s3_Muhammed.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Yusuf',
				person: 'Yusuf',
				gender: 'male',
				languageName: 'Turkish',
				languageCode: "tr-TR",
				languageCodeFull: "tr-TR-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/tr_tr_s4_Yusuf.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/tr_tr_s4_Yusuf.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Maryska',
				person: 'Maryska',
				gender: 'female',
				languageName: 'Ukrainian',
				languageCode: "uk-UA",
				languageCodeFull: "uk-UA-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/uk_ua_s1_Maryska.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/uk_ua_s1_Maryska.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Veronika',
				person: 'Veronika',
				gender: 'female',
				languageName: 'Ukrainian',
				languageCode: "uk-UA",
				languageCodeFull: "uk-UA-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/uk_ua_s2_Veronika.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/uk_ua_s2_Veronika.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Fumiko',
				person: 'Fumiko',
				gender: 'female',
				languageName: 'Japan',
				languageCode: "ja-JP",
				languageCodeFull: "ja-JP-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ja_jp_s2_Fumiko.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ja_jp_s2_Fumiko.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Akira',
				person: 'Akira',
				gender: 'female',
				languageName: 'Japan',
				languageCode: "ja-JP",
				languageCodeFull: "ja-JP-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/ja_jp_s1_Akira.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/ja_jp_s1_Akira.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Susan',
				person: 'Susan',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-F",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s5_Susan.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s5_Susan.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Pamela',
				person: 'Pamela',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s4_Pamela.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s4_Pamela.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Karen',
				person: 'Karen',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s3_Karen.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s3_Karen.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Jodie',
				person: 'Jodie',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-E",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s2_Jodie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s2_Jodie.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Beckie',
				person: 'Beckie',
				gender: 'female',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s1_Beckie.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s1_Beckie.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Wesley',
				person: 'Wesley',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s5_Wesley.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s5_Wesley.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Robin',
				person: 'Robin',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s4_Robin.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s4_Robin.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Jason',
				person: 'Jason',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s3_Jason.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s3_Jason.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Earl',
				person: 'Earl',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s2_Earl.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s2_Earl.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Anthony',
				person: 'Anthony',
				gender: 'male',
				languageName: 'English, US',
				languageCode: "en-US",
				languageCodeFull: "en-US-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_us_s1_Anthony.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_us_s1_Anthony.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Parker',
				person: 'Parker',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s4_Parker.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s4_Parker.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Oliver',
				person: 'Oliver',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s3_Oliver.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s3_Oliver.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Keeton',
				person: 'Keeton',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s2_Keeton.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s2_Keeton.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Alen',
				person: 'Alen',
				gender: 'male',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s1_Alen.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s1_Alen.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Maddy',
				person: 'Maddy',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s4_Maddy.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s4_Maddy.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Hailey',
				person: 'Hailey',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s3_Hailey.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s3_Hailey.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Ella',
				person: 'Ella',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s2_Ella.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s2_Ella.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Alice',
				person: 'Alice',
				gender: 'female',
				languageName: 'English, UK',
				languageCode: "en-GB",
				languageCodeFull: "en-GB-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_gb_s1_Alice.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_gb_s1_Alice.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Mason',
				person: 'Mason',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s4_Mason.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s4_Mason.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Harper',
				person: 'Harper',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s3_Harper.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s3_Harper.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Ethan',
				person: 'Ethan',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-D",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s2_Ethan.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s2_Ethan.oga')
			},
			{
				avatar: AvatarVoiceMIcon,
				title: 'Daymion',
				person: 'Daymion',
				gender: 'male',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-B",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s1_Daymion.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s1_Daymion.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Daisy',
				person: 'Daisy',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s1_Daisy.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s1_Daisy.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Fiona',
				person: 'Fiona',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Standard-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s2_Fiona.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s2_Fiona.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Kiara',
				person: 'Kiara',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-A",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s3_Kiara.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s3_Kiara.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Madeline',
				person: 'Madeline',
				gender: 'female',
				languageName: 'English, Australia',
				languageCode: "en-AU",
				languageCodeFull: "en-AU-Wavenet-C",
				intonation: 'Regular',
				audioLinkMP3: require('../../assets/audio/gallery/en_au_s4_Madeline.mp3'),
				audioLinkOGG: require('../../assets/audio/gallery/en_au_s4_Madeline.oga')
			},
			{
				avatar: AvatarVoiceFIcon,
				title: 'Daria',
				person: 'Daria',
				gender: 'female',
				languageName: 'Bulgarian, Bulgarian',
				languageCode: "bg-Bg",
				languageCodeFull: "bg-Bg",
				intonation: 'Regular',
				audioLinkWav: require('../../assets/audio/gallery/bg_bg_s1_Daria.wav'),
			}
		],
		voices: [],
		characters: [],
		selectedLanguage: null,
		selectedVoice: null,
		selectedCharacter: null,
		formats: ['WAV', 'MP3', 'OGG_OPUS'],
		selectedFormat: null,
		userScript: '',
		userScriptType: '', //options are 'text' or 'ssml'
		fileName: '',
		feedbackDialog: false,
		userCharactersLeft: '?',
	},
	mutations: {
		setSelectedLanguage(state, language) {
			state.selectedLanguage = language;
			if (language) {
				state.voices = language.voices;
				if (state.voices.length == 1) {
					state.selectedVoice = state.voices[0];
					state.characters = state.voices[0].characters;
					if (state.characters.length == 1) {
						state.selectedCharacter = state.characters[0];
					}
				} else {
					state.selectedVoice = null;
					state.selectedCharacter = null;
				}
			}
		},
		setSelectedLanguageByCode(state, languageCode) {
			for (var index in state.languages) {
				if (state.languages[index].code == languageCode) {
					state.selectedLanguage = state.languages[index];
					state.voices = state.languages[index].voices;
					break;
				}
			}
		},
		setSelectedVoice(state, voice) {
			state.selectedVoice = voice;
			if (voice) {
				state.characters = voice.characters;
				if (state.characters.length == 1) {
					state.selectedCharacter = state.characters[0];
				} else {
					state.selectedCharacter = null;
				}
			}
		},
		setSelectedCharacter(state, character) {
			state.selectedCharacter = character;
		},
		setFeedbackDialog(state, dialog) {
			state.feedbackDialog = dialog;
		},
		setUserScript(state, script) {
			state.userScript = script;
		},
		setUserScriptType(state, type) {
			state.userScriptType = type;
		},
		setFileName(state, fileName) {
			state.fileName = fileName;
		},
		setSelectedFormat(state, format) {
			state.selectedFormat = format;
		},
		setUserCharactersLeft(state, chars) {
			state.userCharactersLeft = chars;
		}
	},
	getters: {
		language: state => state.selectedLanguage,
		voice: state => state.selectedVoice,
		character: state => state.selectedCharacter,
		userScript: state => state.userScript,
		userScriptType: state => state.userScriptType,
		fileName: state => state.fileName,
		format: state => state.selectedFormat,
		feedbackDialog: state => state.feedbackDialog,
		userCharactersLeft: state => state.userCharactersLeft,
	},
	actions: {
	}
})



